import { TransformRule, TransformRuleData } from "./TransformRule";

export { Uppercase, UppercaseData };

type UppercaseData = {} & TransformRuleData;

class Uppercase extends TransformRule {
  constructor(data: UppercaseData) {
    super(data);
  }

  getDlfVariables() {
    return [];
  }

  getVariables() {
    return [];
  }

  isConfigured(): boolean {
    return true;
  }

  getRuleId(): string {
    return `${this.getDiscriminator()}-${this.fieldName}-${this.position}`;
  }

  toData(): UppercaseData {
    return {
      discriminator: this.discriminator,
      fieldName: this.fieldName,
      position: this.position,
    };
  }

  static createTest(rest: Partial<UppercaseData> = {}): Uppercase {
    const data: UppercaseData = {
      discriminator: "T_UCASE",
      fieldName: "",
      position: 0,
    };

    return new Uppercase({
      ...data,
      ...rest,
    });
  }
}
